import React from 'react';
import { LabSample } from '../../contexts/LabSampleContext';

interface LabSampleInfoProps {
    sample: LabSample;
}

export const LabSampleInfo: React.FC<LabSampleInfoProps> = ({ sample }) => {
    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h2 className="text-xl font-bold text-gray-900 mb-4">Sample Information</h2>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Sample Type</label>
                    <p className="text-gray-900">{sample.sampleType.replace('_', ' ')}</p>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Serial Number</label>
                    <p className="text-gray-900">{sample.serialNumber || 'N/A'}</p>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Batch/Lot</label>
                    <p className="text-gray-900">{sample.batchLot || 'N/A'}</p>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Source</label>
                    <p className="text-gray-900">{sample.source}</p>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Submitted By</label>
                    <p className="text-gray-900">{sample.submittedBy}</p>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Received Date</label>
                    <p className="text-gray-900">{new Date(sample.receivedDate).toLocaleDateString()}</p>
                </div>
            </div>
        </div>
    );
};
